import React, { useEffect, useState } from "react";
import { decodeStorage } from "newFunctions/storageBase64";
import Styles from './styles.module.sass';

const ModuleCardTitle = (props) => {
    const {
        cardsService
    } = props

    const profileData = decodeStorage('profileData')
    const [ title, setTitle ] = useState("Jovanna")

    useEffect(()=>{
        if(profileData){
            if( typeof profileData === 'object'){
                setTitle(profileData?.nombre)
            }else{
                const profileD = JSON.parse(profileData)
                setTitle(profileD?.nombre)
            }
        }else{
            if(cardsService?.length >= 1){
                setTitle(cardsService?.name)
            }
        }
    },[cardsService])

    return (
        <h1 className={Styles?.titleCardSection}>¡Hola {title}!</h1>
    );
}

export default ModuleCardTitle